/*globals globalThis */
'use strict';
require('core-js/stable');
// require('regenerator-runtime/runtime');
// require('whatwg-fetch');
// require('allsettled-polyfill');
// require('abortcontroller-polyfill/dist/polyfill-patch-fetch');

// webpack@5 doesn't inject node polyfill automatically
let g =
  typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window === 'undefined'
    ? global
    : window.global || window;
g.process = g.process || {};
g.process.env = g.process.env || {};
g.process.cwd = () => '/';

if (!globalThis.global) {
  globalThis.global = g;
}
